import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { SortingTypeIndex } from '../../constants/sortingType';

import { EncodedStateFilterProvider } from './EncodedStateFilterProvider';

const EncodedStateFilter: FC<React.PropsWithChildren<{ initialSorting?: SortingTypeIndex }>> = ({ children, initialSorting }) => {
  const { data } = useParams<{ data: string }>();

  return (
    <EncodedStateFilterProvider encodedState={data} initialSorting={initialSorting}>
      {children}
    </EncodedStateFilterProvider>
  );
};

export default EncodedStateFilter;
import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { SortingTypeIndex } from '../../constants/sortingType';

import { EncodedStateFilterProvider } from './EncodedStateFilterProvider';

const EncodedStateFilter: FC<React.PropsWithChildren<{ initialSorting?: SortingTypeIndex }>> = ({ children, initialSorting }) => {
  const { data } = useParams<{ data: string }>();

  return (
    <EncodedStateFilterProvider encodedState={data} initialSorting={initialSorting}>
      {children}
    </EncodedStateFilterProvider>
  );
};

export default EncodedStateFilter;
